import { __read } from "tslib";
export var CountryCodes;
(function (CountryCodes) {
    CountryCodes["BE"] = "BE";
    CountryCodes["DE"] = "DE";
    CountryCodes["ES"] = "ES";
    CountryCodes["FR"] = "FR";
    CountryCodes["GB"] = "GB";
    CountryCodes["IT"] = "IT";
    CountryCodes["LU"] = "LU";
    CountryCodes["NL"] = "NL";
    CountryCodes["NO"] = "NO";
    CountryCodes["PT"] = "PT";
    CountryCodes["US"] = "US";
    CountryCodes["PL"] = "PL";
    CountryCodes["GR"] = "GR";
    CountryCodes["SE"] = "SE";
    CountryCodes["TR"] = "TR";
    CountryCodes["CZ"] = "CZ";
    CountryCodes["FI"] = "FI";
    CountryCodes["DK"] = "DK";
    CountryCodes["AT"] = "AT";
    CountryCodes["AU"] = "AU";
    CountryCodes["BR"] = "BR";
    CountryCodes["CA"] = "CA";
    CountryCodes["HU"] = "HU";
    CountryCodes["IN"] = "IN";
    CountryCodes["IE"] = "IE";
    CountryCodes["MX"] = "MX";
    CountryCodes["RO"] = "RO";
    CountryCodes["NZ"] = "NZ";
    CountryCodes["RU"] = "RU";
    CountryCodes["SK"] = "SK";
    CountryCodes["CH"] = "CH";
    CountryCodes["AE"] = "AE";
    CountryCodes["INT"] = "INT";
})(CountryCodes || (CountryCodes = {}));
export var CountryNames;
(function (CountryNames) {
    CountryNames["AE"] = "United Arab Emirates";
    CountryNames["AT"] = "Austria";
    CountryNames["AU"] = "Australia";
    CountryNames["BE"] = "Belgium";
    CountryNames["BR"] = "Brazil";
    CountryNames["CA"] = "Canada";
    CountryNames["CH"] = "Switzerland";
    CountryNames["CZ"] = "Czech Republic";
    CountryNames["DE"] = "Germany";
    CountryNames["DK"] = "Denmark";
    CountryNames["ES"] = "Spain";
    CountryNames["FI"] = "Finland";
    CountryNames["FR"] = "France";
    CountryNames["GB"] = "United Kingdom";
    CountryNames["GR"] = "Greece";
    CountryNames["HU"] = "Hungary";
    CountryNames["IE"] = "Ireland";
    CountryNames["IN"] = "India";
    CountryNames["INT"] = "International";
    CountryNames["IT"] = "Italy";
    CountryNames["LU"] = "Luxembourg";
    CountryNames["MX"] = "Mexico";
    CountryNames["NL"] = "Netherlands";
    CountryNames["NO"] = "Norway";
    CountryNames["NZ"] = "New Zealand";
    CountryNames["PL"] = "Poland";
    CountryNames["PT"] = "Portugal";
    CountryNames["RO"] = "Romania";
    CountryNames["RU"] = "Russia";
    CountryNames["SE"] = "Sweden";
    CountryNames["SK"] = "Slovakia";
    CountryNames["TR"] = "Turkey";
    CountryNames["US"] = "United States";
})(CountryNames || (CountryNames = {}));
export var CountryPhoneCodes;
(function (CountryPhoneCodes) {
    CountryPhoneCodes["AE"] = "971";
    CountryPhoneCodes["AT"] = "43";
    CountryPhoneCodes["AU"] = "61";
    CountryPhoneCodes["BE"] = "32";
    CountryPhoneCodes["BR"] = "55";
    CountryPhoneCodes["CA"] = "1";
    CountryPhoneCodes["CH"] = "41";
    CountryPhoneCodes["CZ"] = "420";
    CountryPhoneCodes["DE"] = "49";
    CountryPhoneCodes["DK"] = "45";
    CountryPhoneCodes["ES"] = "34";
    CountryPhoneCodes["FI"] = "358";
    CountryPhoneCodes["FR"] = "33";
    CountryPhoneCodes["GB"] = "44";
    CountryPhoneCodes["GR"] = "30";
    CountryPhoneCodes["HU"] = "36";
    CountryPhoneCodes["IE"] = "353";
    CountryPhoneCodes["IN"] = "91";
    CountryPhoneCodes["INT"] = "";
    CountryPhoneCodes["IT"] = "39";
    CountryPhoneCodes["LU"] = "352";
    CountryPhoneCodes["MX"] = "52";
    CountryPhoneCodes["NL"] = "31";
    CountryPhoneCodes["NO"] = "47";
    CountryPhoneCodes["NZ"] = "64";
    CountryPhoneCodes["PL"] = "48";
    CountryPhoneCodes["PT"] = "351";
    CountryPhoneCodes["RO"] = "40";
    CountryPhoneCodes["RU"] = "7";
    CountryPhoneCodes["SE"] = "46";
    CountryPhoneCodes["SK"] = "421";
    CountryPhoneCodes["TR"] = "90";
    CountryPhoneCodes["US"] = "1";
})(CountryPhoneCodes || (CountryPhoneCodes = {}));
// Countries Object could be replaced with this library: https://github.com/catamphetamine/libphonenumber-js
// Also it provides ability to use country specific formatting and validation
export var Countries = Object.freeze(Object.entries(CountryCodes).reduce(function (acc, _a) {
    var _b = __read(_a, 2), key = _b[0], val = _b[1];
    acc[key] = {
        countryCode: val,
        name: CountryNames[key],
        countryPhoneCode: CountryPhoneCodes[key],
        flagName: val,
    };
    return acc;
}, {}));
export var SortedCountries = Object.freeze(Object.values(Countries)
    .sort(function (_a, _b) {
    var nameA = _a.name, countryPhoneCodeA = _a.countryPhoneCode;
    var nameB = _b.name, countryPhoneCodeB = _b.countryPhoneCode;
    if (countryPhoneCodeA > countryPhoneCodeB) {
        return 1;
    }
    if (countryPhoneCodeA === countryPhoneCodeB && nameA > nameB) {
        return 1;
    }
    return -1;
})
    .filter(function (_a) {
    var name = _a.name;
    return name !== CountryNames.INT;
}));
export var DEBOUNCED_TIMEOUT = 1000;
//# sourceMappingURL=constants.js.map